import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquarePlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect, useRef, useState } from 'react';
import Webcam from 'react-webcam';

const CameraModal = ({ isOpen, onClose,onCapture }) => {
  // const videoRef = useRef(null);
  // const canvasRef = useRef(null);
  // const [image, setImage] = useState(null);
 const webcamRef = useRef(null);
 
  //const [capturedImages, setCapturedImages] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();    
    onCapture(imageSrc); // Send to parent
  };

  // Open the modal
  const openModal = () => {
    setIsModalOpen(true);
  };

  // Close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // useEffect(() => {
  //   if (isOpen) {
  //     startCamera();
  //   } else {
  //     stopCamera();
  //   }
  // }, [isOpen]);

  // const startCamera = async () => {
  //   try {
  //     const stream = await navigator.mediaDevices.getUserMedia({ video: true });
  //     if (videoRef.current) {
  //       videoRef.current.srcObject = stream;
  //     }
  //   } catch (error) {
  //     console.error("Error accessing camera", error);
  //   }
  // };

  // const stopCamera = () => {
  //   const stream = videoRef.current?.srcObject;
  //   if (stream) {
  //     const tracks = stream.getTracks();
  //     tracks.forEach((track) => track.stop());
  //     videoRef.current.srcObject = null;
  //   }
  // };

  // const captureImage = () => {
  //   const video = videoRef.current;
  //   const canvas = canvasRef.current;
  //   if (video && canvas) {
  //     canvas.width = video.videoWidth;
  //     canvas.height = video.videoHeight;
  //     const ctx = canvas.getContext("2d");
  //     ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  //     const imageData = canvas.toDataURL("image/png");
  //     onCapture(imageData); // Send to parent
  //     setImage(imageData);
  //     stopCamera();
  //     setImage(null);
  //     onClose();
  //   }
  // };

  if (!isOpen) return null;


  return (
    <>


      {/* Modal */}

      <div className="modal fade show modal-top-spacing" id="myModal" tabIndex="-1" style={{ display: "block" }}>
        <div className="modal-dialog" style={{ width: "322px" }}>
          <div className="modal-content">
            <div className="modal-body" style={{padding:"0px 0px 0px 0px",marginBottom: "-6px"}}>
                    {/* <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
                      <div className="bg-white p-1 rounded-lg relative w-full max-w-md">

                        {!image ? (
                          <div>
                            <video ref={videoRef} autoPlay className="w-full rounded" style={{ width: "100%" }} />

                          </div>
                        ) : (
                          <div>
                            <img src={image} alt="Captured" className="w-full rounded" />
                           
                          </div>
                        )}

                        <canvas ref={canvasRef} style={{ display: "none" }} />
                      </div>
                    </div> */}


                  <Webcam
                            audio={false}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            width={320}
                          />
                          <div>
                            {/* <button type='button' onClick={capture}>Capture</button> */}
                            {/* <button onClick={saveImages}>Save</button> */}
                            {/* <button type='button' onClick={closeModal}>Close</button> */}
                          </div>
                          {/* <div>
                            {capturedImages.map((img, idx) => (
                              <img key={idx} src={img} alt={`Captured ${idx}`} width={100} />
                            ))}
                          </div> */}

          </div>
            <div className="modal-footer"  style={{padding:"0px 0px 0px 0px"}}>
              <button type="button" style={{ display: 'none' }} id="btnCapture"  onClick={capture} className="btn btn-primary btn-sm px-2 py-1">
                Capture
              </button>
              <button type="button" style={{ display: 'none' }}  id="btnClose" className="btn btn-danger  btn-sm px-2 py-1" onClick={() => { onClose(); }}>
                Close
              </button>

              <label htmlFor="btnCapture"  style={{ cursor: 'pointer' }}>
                {/* <i className="fa-solid fa-square-plus" style={{fontSize:"25px"}}></i>   */}
                <FontAwesomeIcon style={{ cursor: 'pointer' ,fontSize:"25px"}} icon={faSquarePlus} /> 
              </label>
              &nbsp;&nbsp;
              <label htmlFor="btnClose"  style={{ cursor: 'pointer' }}>
                {/* <i className="fa-solid fa-xmark" style={{fontSize:"25px"}}></i>   */}
                <FontAwesomeIcon style={{ cursor: 'pointer' ,fontSize:"25px"}} icon={faXmark} /> 
              </label>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}

export default CameraModal;
